'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SavedSearchForm = require('./components/SavedSearchForm.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SavedSearchForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/saved-search/lib/components/saved-search-form/index.js
// module id = 1467
// module chunks = 1